import { Box, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../../../constants/theme';
import { useThemeContext } from '../../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../../types/global/fonts.types';
import { getJWtDetails } from '../../../../utils/AppUtils';
import { ThspianAvatar } from '../../../Avatar/ThspianAvatar';

interface IDashboardTabWrapper {
    tabText: string;
    profile_pic?: string; // Remove
    children: React.ReactElement;
    customRightComponent?: React.ReactElement;
}

export const DashboardTabWrapper: React.FC<IDashboardTabWrapper> = ({ tabText, children, customRightComponent }) => {
    const { themeStyle } = useThemeContext();
    const { user } = getJWtDetails();

    return (
        <Box
            style={{
                backgroundColor: theme[themeStyle].gray_text,
                boxShadow: `0px 0px 3px ${theme[themeStyle].gray_sidebar}`,
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                width: '100%',
                minHeight: '100%',
                padding: '32px',
                overflow: 'hidden',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* Welcome message */}
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: theme[themeStyle].form_label }}>
                        Welcome back!
                    </Typography>
                    <Typography
                        sx={{
                            color: theme[themeStyle].form_label,
                            fontSize: 14,
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        }}>
                        {tabText}
                    </Typography>
                </Box>

                {/* Profile picture  */}
                {customRightComponent ? (
                    <Box sx={{ display: 'flex', marginLeft: 'auto' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            {customRightComponent}
                        </Box>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', marginLeft: 'auto' }}>
                        <Box
                            sx={{
                                height: 40,
                                width: 40,
                                borderRadius: '50%',
                                cursor: 'pointer',
                                border: `1px solid ${theme[themeStyle].disabledGray}`,
                                flexShrink: 0,
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            {customRightComponent ?? <ThspianAvatar user={user} size="medium" />}
                        </Box>
                    </Box>
                )}
            </Box>
            {children}
        </Box>
    );
};
